"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _commonReact = require("@devsta/common-react");

var _api = require("../api");

var _BrandInfoRoot = _interopRequireDefault(require("../components/BrandInfoRoot"));

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BrandInfoRootComponent = (0, _commonReact.requiresPermission)({
  ComponentToRender: _BrandInfoRoot.default,
  requiredPermission: 'MANAGE_ORGANISATION',
  isRoute: true
});

function BrandInfo(_ref) {
  var history = _ref.history,
      subBrandId = _ref.match.params.id;
  return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref2) {
    var fetchAssets = _ref2.fetchAssets;
    return _react.default.createElement(_commonReact.AuthorisationConsumer, {
      requiresOrganisation: true
    }, function (_ref3) {
      var organisationId = _ref3.selectedOrganisation.organisationId;
      return _react.default.createElement(_commonReact.RequestProvider, {
        requests: _objectSpread({}, subBrandId ? {
          getOrganisationSubBrand: (0, _api.getOrganisationSubBrandQuery)(subBrandId)
        } : {}, {
          upsertOrganisationSubBrand: subBrandId ? (0, _api.updateOrganisationSubBrandQuery)(organisationId, subBrandId) : (0, _api.createOrganisationSubBrandQuery)(organisationId)
        })
      }, function (_ref4) {
        var getOrganisationSubBrand = _ref4.getOrganisationSubBrand,
            upsertOrganisationSubBrand = _ref4.upsertOrganisationSubBrand;
        return _react.default.createElement(BrandInfoRootComponent, {
          history: history,
          fetchAssets: fetchAssets,
          getOrganisationSubBrand: getOrganisationSubBrand,
          upsertOrganisationSubBrand: upsertOrganisationSubBrand
        });
      });
    });
  });
}

var _default = (0, _withBasedRouter.default)(_basePath.default, BrandInfo);

exports.default = _default;